$(document).ready(function() {
  // Slowly going through these, trying to remove well.. all of them
  // menuMobile();
  // closeMenu();
  slideMenuMobile();
  changePlusMinus();
  cartInRight();
  menuLogin();
  // searchPopUp();
  // loginRegister();
  // loginPopup();
  searchBoxPullRight();
  cartCheckOut();
  SortTabContent();
  testimonialV1Slide();
  testimonialV2();
  testimonialAboutUs();
  // matchHeight();
  productDetail();
  tabProdDetail();
  tabProdDetailv2();
  jsSortProd();
  FilterInRight();
  menuSlideshow();
  totop();
});
function menuMobile() {
  $(".menu-left").click(function() {
    $("header, #menu-left, .menu-hamburger i").toggleClass("active");
  });
  $(".menu-search").click(function() {
    $("#mobile-search, .menu-search").toggleClass("active");
  });
  $(".mobile-category h5").click(function() {
    $(this).toggleClass("active");
    $(this)
      .next("ul")
      .toggleClass("active");
  });
}
function slideMenuMobile() {
  $(".js-btn-menu-mobile").on("click", function() {
    $(".js-menu-mobile").toggleClass("active");
    $(".js-background-overlay").toggleClass("active");
  });
  $(".js-menu-mobile-close").on("click", function() {
    $(".js-menu-mobile").removeClass("active");
    $(".js-background-overlay").removeClass("active");
  });
  $(".js-background-overlay").on("click", function() {
    $(this).removeClass("active");
    $(".js-menu-mobile").removeClass("active");
  });
}
function changePlusMinus() {
  $(".change-btn-angle").on("click", function() {
    $(this)
      .find(".btn-angle")
      .toggleClass("active");
  });
  $(".plus-minus2").on("click", function() {
    $(".change-plus-minus2").toggleClass("fa-minus");
  });
  $(".plus-minus3").on("click", function() {
    $(".change-plus-minus3").toggleClass("fa-minus");
  });
  $(".plus-minus4").on("click", function() {
    $(".change-plus-minus4").toggleClass("fa-minus");
  });
  $(".plus-minus5").on("click", function() {
    $(".change-plus-minus5").toggleClass("fa-minus");
  });
}
function closeMenu() {
  $(".menu-hamburger").on("click", function() {
    $(this).toggleClass("active");
    $(".box").toggleClass("active");
    //        $('.content-login').hide();
    //       $('.content-register').hide();
    $(".menu-mobile-overlay").toggleClass("active");
  });
  $(".menu-mobile-overlay").on("click", function() {
    $(this).removeClass("active");
    $(".box").removeClass("active");
    $(".menu-hamburger").removeClass("active");
  });
}
function cartInRight() {
  $(".js-cart-pull-right").on("click", function() {
    $(".js-cart-popup").toggleClass("active");
    $(".js-bg").toggleClass("active");
  });
  $(".js-bg").on("click", function() {
    $(this).removeClass("active");
    $(".js-cart-popup").removeClass("active");
  });
  $(".closebtn").on("click", function() {
    $(".js-bg").removeClass("active");
    $(".js-cart-popup").removeClass("active");
  });
}
function menuLogin() {
  $(".title-login").on("click", function() {
    $(this).addClass("active");
    $(".title-menu").addClass("active");
    $(".menu-content").hide();
    $(".content-login").addClass("active");
  });
  $(".title-menu").on("click", function() {
    $(this).removeClass("active");
    $(".title-login").removeClass("active");
    $(".menu-content").show();
    $(".content-login").removeClass("active");
    $(".content-register").removeClass("active");
  });
  $(".creat-acc").on("click", function() {
    $(".content-login").removeClass("active");
    $(".content-register").addClass("active");
  });
  $(".back-login").on("click", function() {
    $(".content-login").addClass("active");
    $(".content-register").removeClass("active");
  });
}
function searchPopUp() {
  $(".js-search").on("click", function() {
    $(".search-mobile").toggleClass("active");
    $(".bg-search-mobile").toggleClass("active");
  });
  $(".bg-search-mobile").on("click", function() {
    $(this).removeClass("active");
    $(".search-mobile").removeClass("active");
  });
  $(".close-src-mobile").on("click", function() {
    $(".bg-search-mobile").removeClass("active");
    $(".search-mobile").removeClass("active");
  });
}

function loginPopup() {
  var xxx = 0;
  $(".js-login-popup").click(function() {
    xxx = 1;
  });
  $(".js-bg-login").click(function() {
    if (xxx == 0) {
      $(".js-bg-login").removeClass("active");
      $(".js-login-popup").removeClass("active");
    } else {
      xxx = 0;
    }
  });
  $(".login-test").on("click", function() {
    $(".js-login-popup").toggleClass("active");
    $(".js-bg-login").toggleClass("active");
  });
  $(".closebtn-login").on("click", function() {
    $(".js-bg-login").removeClass("active");
    $(".js-login-popup").removeClass("active");
  });
}
// Scroll to TOP
function totop() {
  var back_to_top = $("#back-to-top");
  if (back_to_top.length) {
    var scrollTrigger = 100, // px
      backToTop = function() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > scrollTrigger) {
          back_to_top.addClass("show");
        } else {
          back_to_top.removeClass("show");
        }
      };
    $(window).on("scroll", function() {
      backToTop();
    });
    back_to_top.on("click", function(e) {
      e.preventDefault();
      $("html,body").animate(
        {
          scrollTop: 0
        },
        700
      );
    });
  }
}
function loginRegister() {
  $(".js-account-admin").click(function() {
    $(".customer-form").show();
    $(".customer-form-register").hide();
  });
  $(".login-test").click(function() {
    $(".customer-form").show();
    $(".customer-form-register").hide();
  });
  $(".creat-acc").click(function() {
    $(".customer-form").hide();
    $(".customer-form-register").show();
  });
  $(".back-login").click(function() {
    $(".customer-form").show();
    $(".customer-form-register").hide();
  });
}
function matchHeight() {
  jQuery(function() {
    jQuery(".matchHeight").matchHeight();
  });
}
function searchBoxPullRight() {
  $(".ic-search-btn").on("click", function() {
    $(".search-box-dsk").toggleClass("active");
  });
}
function cartCheckOut() {
  $(".js-cart-checkout").on("click", function() {
    $(".cart-checkout").toggleClass("active");
  });
}
function SortTabContent() {
  $(".product-v1")
    .find("ul")
    .children()
    .eq(2)
    .addClass("active");
  $(".product-v1")
    .find(".tab-content")
    .eq(2)
    .removeClass("active1")
    .addClass("x active2");
  $(".product-v1")
    .find("li")
    .each(function() {
      $(this).on("click", function() {
        var link = $(this)
          .find("a")
          .attr("data-target");
        $(".product-v1")
          .find(".x")
          .addClass("active1")
          .removeClass("x active2");
        $(".product-v1")
          .find(".active")
          .removeClass("active");
        $("#" + link)
          .removeClass("active1")
          .addClass("x active2");
        $(this).addClass("active");
      });
    });
}
function tabProdDetail() {
  $(".product-tab-info1")
    .find("ul")
    .children()
    .eq(0)
    .addClass("active");
  $(".content-tab-des1").addClass("x active");
  $(".product-tab-info1")
    .find("li")
    .each(function() {
      $(this).on("click", function() {
        var link = $(this)
          .find("a")
          .attr("data-target");
        $(".product-tab-info1")
          .find(".x")
          .removeClass("x active");
        $(".product-tab-info1")
          .find(".active")
          .removeClass("active");
        $("#" + link).addClass("x active");
        $(this).addClass("active");
      });
    });
}
function tabProdDetailv2() {
  $(".product-tab-info2")
    .find("ul")
    .children()
    .eq(0)
    .addClass("active");
  $(".content-tab-des2").addClass("y active");
  $(".product-tab-info2")
    .find("li")
    .each(function() {
      $(this).on("click", function() {
        var link = $(this)
          .find("a")
          .attr("data-target");
        $(".product-tab-info2")
          .find(".y")
          .removeClass("y active");
        $(".product-tab-info2")
          .find(".active")
          .removeClass("active");
        $("#" + link).addClass("y active");
        $(this).addClass("active");
      });
    });
}
function testimonialV1Slide() {
  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav"
  });
  $(".slider-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    prevArrow:
      '<button type="button" class="prev-slide"> <img src="//cdn.shopify.com/s/files/1/0050/2811/8577/t/7/assets/next-copy1.png?6322""></button>',
    nextArrow:
      '<button type="button" class="next-slide"> <img src="//cdn.shopify.com/s/files/1/0050/2811/8577/t/7/assets/next2.png?6322" "></button>',
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
function productDetail() {
  $(".product-img-parent")
    .show()
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: false,
      asNavFor: ".product-img-sub"
    });
  $(".product-img-sub")
    .show()
    .slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: ".product-img-parent",
      dots: false,
      prevArrow:
        '<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow:
        '<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
}
function testimonialV2() {
  $(".js-testimonial-v2").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="prev-slide"><i class="fa fa-angle-double-left" aria-hidden="true"></i></button>',
    nextArrow:
      '<button type="button" class="next-slide"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>',
    autoplaySpeed: 2000
  });
}
function menuSlideshow() {
  $(".js-menu-slideshow").slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    infinite: true,
    adaptiveHeight: true
  });
  $(".js-menu-slideshow .slide-show img")
    .eq(0)
    .addClass("active");
  $(".js-menu-slideshow .slide-show .content-slide")
    .eq(0)
    .addClass("active");
  $(".js-menu-slideshow").on("beforeChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    var mySlideNumber = nextSlide;
    var prev = mySlideNumber - 1;
    $(".js-menu-slideshow .slide-show img")
      .eq(mySlideNumber)
      .addClass("active");
    $(".js-menu-slideshow .slide-show .content-slide")
      .eq(mySlideNumber)
      .addClass("active");
    $(".js-menu-slideshow .slide-show img")
      .eq(prev)
      .removeClass("active");
    $(".js-menu-slideshow .slide-show .content-slide")
      .eq(prev)
      .removeClass("active");
  });
}
function testimonialAboutUs() {
  $(".js-testimonial-about-us").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 2000
  });
}
function jsSortProd() {
  $(".js-sort-prod-grid").on("click", function() {
    $(".js-prod-items").removeClass("product-item-list");
    $(".js-prod-items").addClass("product-item-grid ");
    $(this).addClass("active");
    $(".js-sort-prod-list").removeClass("active");
  });
  $(".js-sort-prod-list").on("click", function() {
    $(".js-prod-items").removeClass("product-item-grid");
    $(".js-prod-items").addClass("product-item-list");
    $(this).addClass("active");
    $(".js-sort-prod-grid").removeClass("active");
  });
}
function FilterInRight() {
  $(".button-filter").on("click", function() {
    $(this).toggleClass("d-none");
    $(".change-button-filter").toggleClass("d-block");
    $(".filter-mobile ").toggleClass("active");
    $(".bg-filter-overlay").toggleClass("active");
  });
  $(".change-button-filter").on("click", function() {
    $(this).addClass("d-none");
    $(this).removeClass("d-block");
    $(".button-filter").removeClass("d-none");
    $(".button-filter").addClass("d-block");
    $(".filter-mobile ").removeClass("active");
    $(".bg-filter-overlay").removeClass("active");
  });
  $(".bg-filter-overlay").on("click", function() {
    $(this).removeClass("active");
    $(".filter-mobile ").removeClass("active");
    $(".change-button-filter").removeClass("d-block");
    $(".button-filter").removeClass("d-none");
    $(".button-filter").addClass("d-block");
  });
  $(".closebtn-filter").on("click", function() {
    $(".change-button-filter").removeClass("d-block");
    $(".button-filter").removeClass("d-none");
    $(".button-filter").addClass("d-block");
    $(".bg-filter-overlay").removeClass("active");
    $(".filter-mobile").removeClass("active");
  });
}
